import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getOrganisationIATADetail } from '../../../../../Redux/action/Organisation/OrganisationListAction';
import useSelection from 'antd/es/table/hooks/useSelection';
import { capitalizeFirstLetter, convertDateYYYYMMDDToDDMMYYYY } from '../../../../../HelperFunctions';

const EditReg = ({ show, handleClose, refreshREG, token, user_id, b64id, editRegObject, addEdit, branchList }) => {

    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);


    const dispatch = useDispatch();
    const initialValues = {
        registration_type: "",
        registration_no: "",
        branch_id: "",
        registration_date: "",
        valid_upto: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: values => {
            console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.customer_id = atob(b64id);
                if (editRegObject.id) {
                    values.id = editRegObject.id
                }
                if (values.valid_upto && values.registration_date) {
                    const regDate = new Date(values.registration_date);
                    const validDate = new Date(values.valid_upto);

                    // Check if valid_upto is earlier than registration_date
                    if (validDate < regDate) {
                        toast.error("Valid Upto date cannot be earlier than Registration Date");
                        return;
                    }
                }

                if (values.valid_upto) { values.valid_upto = convertDateYYYYMMDDToDDMMYYYY(values.valid_upto) }
                if (values.registration_date) { values.registration_date = convertDateYYYYMMDDToDDMMYYYY(values.registration_date) }



                axios.post(`${adminMainUrl}/api/organization/reg/${addEdit}`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refreshREG();
                            handleClose();
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(err => {
                        let msg = "Internal server error!";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.msg) {
                                    msg = err.response.data.msg
                                }
                            }
                        };
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                setDisableSubmit(false);
                toast.error(error.message);
            }
        }
    });


    useEffect(() => {
        // console.log(editRegObject);
        if (editRegObject) {
            formik.setFieldValue("registration_type", editRegObject?.registration_type);
            formik.setFieldValue("registration_no", editRegObject?.registration_no);
            formik.setFieldValue("branch_id", Number(editRegObject?.branch_id));
            formik.setFieldValue("registration_date", editRegObject?.registration_date);
            formik.setFieldValue("valid_upto", editRegObject?.valid_upto);
        }
    }, [editRegObject])




    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement='end' name="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{capitalizeFirstLetter(addEdit)} {formik.values.registration_type}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <form onSubmit={formik.handleSubmit} className='row'>
                            {/* <div className="col-md-12">
                                <label htmlFor="airline" className="form-label">Registration Type</label>
                            </div> */}
                            <div className="col-md-12">
                                <label htmlFor="airline" className="form-label">Registration No.</label>
                                <input
                                    type='text'
                                    maxLength={30}
                                    className='form-control form-control-sm'
                                    id="registration_no"
                                    name="registration_no"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.registration_no}
                                    onInput={e => {
                                        e.target.value = e.target.value.replace(/\s/g, '');
                                        formik.setFieldValue('registration_no', e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-md-12">
                                <label htmlFor="airline" className="form-label">Branch</label>
                                <select
                                    className='form-control form-control-sm'
                                    id="branch_id"
                                    name="branch_id"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.branch_id}
                                >
                                    <option>-Select a branch-</option>
                                    {branchList.map((v, i) => {
                                        return <option key={i + 1} value={v.id}>{v.name}</option>
                                    })}

                                </select>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="airline" className="form-label">Registration Date</label>
                                <input
                                    type='date'
                                    className='form-control form-control-sm'
                                    id="registration_date"
                                    name="registration_date"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.registration_date}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="airline" className="form-label">Valid Upto</label>
                                <input
                                    type='date'
                                    className='form-control form-control-sm'
                                    id="valid_upto"
                                    name="valid_upto"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.valid_upto}
                                />
                            </div>
                            <div className="col-md-12 text-end mt-2">
                                <button className="btn btn-submit btn-danger">Submit</button>
                            </div>
                        </form>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EditReg